const EVENT = 'silkreels:points-refresh'

/** AI 扣费 / 解冻等场景触发积分余额立即刷新 */
export function notifyPointsRefresh() {
  window.dispatchEvent(new Event(EVENT))
}

export function subscribePointsRefresh(handler: () => void) {
  window.addEventListener(EVENT, handler)
  return () => window.removeEventListener(EVENT, handler)
}
